import { useRouterHistory } from "react-router";
import { createHistory } from "history";
import { get } from "lodash";

export const browserHistory = useRouterHistory(createHistory)({
  basename: get(window, "initialProps.basename", "")
});
